var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseroundicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_62)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99995 0C9.31369 0 12 2.68623 12 5.9999C12 9.31367 9.31369 11.9999 5.99995 11.9999C2.68631 12 0 9.31367 0 5.9999C0 2.68623 2.68631 0 5.99995 0ZM7.98031 3.5377C8.11341 3.40459 8.32913 3.40459 8.46233 3.5377C8.59544 3.6708 8.59544 3.88662 8.46233 4.01973L6.48188 5.9999L8.46224 7.98018C8.59534 8.11328 8.59534 8.3291 8.46224 8.4623C8.32913 8.59531 8.11341 8.59531 7.98021 8.4623L5.99995 6.48203L4.01969 8.4623C3.88669 8.59531 3.67077 8.59531 3.53767 8.4623C3.40456 8.3292 3.40456 8.11338 3.53767 7.98018L5.51792 5.9999L3.53767 4.01973C3.40456 3.88662 3.40456 3.6708 3.53767 3.5377C3.67077 3.40459 3.88659 3.40459 4.01969 3.5377L5.99995 5.51797L7.98031 3.5377Z",
    fill: "#FC706E",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseroundicon1);
export default __webpack_public_path__ + "static/media/closeroundicon-1.382ac072636163ec2e72717ee47308d2.svg";
export { ForwardRef as ReactComponent };